export default __webpack_public_path__ + "static/media/webx-logo.f5b3ece3.png";